import { parse } from 'query-string'
import { useLocation } from 'react-router-dom'
import { useUseCompanyQuery } from '../graphql'

function useCompany() {
  const { search } = useLocation()
  const { companyId } = parse(search)
  const skip = !companyId
  return useUseCompanyQuery({
    variables: {
      id: String(companyId),
    },
    skip,
  })
}

export default useCompany
